// Placeholder card shown while the homepage GraphQL query is loading on a
// cold cache. Mirrors GameCard's shape (square image + title + price block)
// so sections keep a stable layout and content fades in without a pop-in.
export function GameCardSkeleton() {
  return (
    <div className="card overflow-hidden" aria-hidden="true">
      <div className="aspect-square animate-pulse bg-gray-200" />
      <div className="p-4">
        <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
        <div className="mt-2 h-3 w-1/3 animate-pulse rounded bg-gray-200" />
        <div className="mt-4 h-7 w-1/2 animate-pulse rounded bg-gray-200" />
        <div className="mt-2 h-3 w-2/5 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  );
}
